import React, { useContext, useEffect, useState } from 'react';
import { Components } from '../../styled';
import ProjectTableHeader from '../../../../components/ProjectTableHeader';
import useFormTextState from '../../../../hooks/useFormTextState';
import ProjectTable from '../../../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../../../hooks/useModalState';
import { DailyMissionTemplate } from '../../../../api/types/progress';
import { deleteDailyMissionTemplate, getAllDailyMissionTemplates } from '../../../../api/progress';
import CreateOrEditDailyMissionTemplateModal from '../../../../components/modals/CreateOrEditDailyMissionTemplateModal';

const DailyMissionTemplates = ({
  setShouldRefreshContext,
}: {
  setShouldRefreshContext: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<DailyMissionTemplate[]>([]);

  const searchProps = useFormTextState();

  const createMissionModalProps = useModalState<{ mission?: DailyMissionTemplate }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllDailyMissionTemplates();
    setIsLoading(false);
    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData().then();
  }, []);

  const onAddMission = () => {
    createMissionModalProps.open({ mission: undefined });
  };
  const onEditMission = (id: string) => {
    const foundMission = data?.find((item) => item?.id === id);
    if (foundMission) {
      createMissionModalProps.open({ mission: foundMission });
    }
  };

  const onDeleteMission = async (id: string) => {
    setIsLoading(true);
    await deleteDailyMissionTemplate(id);
    setIsLoading(false);
    await refreshData();
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
      setShouldRefreshContext(true);
    }
    createMissionModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'searchValue', value: searchProps.value, operatorValue: 'contains' },
  ]);
  return (
    <Components.ComponentContainer>
      <ProjectTableHeader
        onSearchChange={searchProps.onChangeText}
        searchLabel={'Search by mission title or ID'}
        searchPlaceholder={'Enter search term'}>
        <Components.SearchBarSeparator />
        <Components.PrimaryButton onClick={onAddMission}>Add Daily Mission</Components.PrimaryButton>
      </ProjectTableHeader>
      <Components.TableWrapper>
        <ProjectTable
          data={data || []}
          columns={tableColumns.dailyMissionTemplates({ onEdit: onEditMission, onDelete: onDeleteMission })}
          filteringModel={_filteringModel}
          showRowCountText={'Found daily missions'}
          customPageSize={15}
          sortingModel={{ field: 'order', sort: 'asc' }}
        />
      </Components.TableWrapper>
      <CreateOrEditDailyMissionTemplateModal
        {...createMissionModalProps}
        onModalClose={onCreateOrEditModalClose}
        refreshCallback={refreshData}
      />
    </Components.ComponentContainer>
  );
};

export default DailyMissionTemplates;
